import { useMutation } from 'react-query';
import useAuthStore from '../store/authStore';
import { forgotPassword, resetPassword, verifyResetToken } from '../api/forgetpasswordApi';

export const useForgotPassword = () => {
  const { setError, setLoading } = useAuthStore();

  const forgotPasswordMutation = useMutation(
    async (email) => {
      try {
        const response = await forgotPassword(email);
        return response;
      } catch (error) {
        throw error;
      }
    },
    {
      onMutate: () => {
        setLoading(true);
        setError(null);
      },
      onSuccess: () => {
        setError(null);
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
        if (error?.response?.data?.message) {
          setError(error.response.data.message);
        } else {
          setError('Failed to send reset link');
        }
      },
      onSettled: () => {
        setLoading(false);
      }
    }
  );

  const resetPasswordMutation = useMutation(
    async ({ token, newPassword }) => {
      try {
        const response = await resetPassword(token, newPassword);
        return response;
      } catch (error) {
        throw error;
      }
    },
    {
      onError: (error) => {
        setError(error?.response?.data?.message || 'Failed to reset password');
      }
    }
  );

  const verifyTokenMutation = useMutation(
    async (token) => {
      try {
        const response = await verifyResetToken(token);
        return response;
      } catch (error) {
        throw error;
      }
    },
    {
      onError: (error) => {
        setError(error?.response?.data?.message || 'Invalid or expired reset token');
      }
    }
  );

  return {
    sendResetLink: forgotPasswordMutation.mutateAsync,
    resetPassword: resetPasswordMutation.mutate,
    verifyToken: verifyTokenMutation.mutate,
    isLoading: forgotPasswordMutation.isLoading || 
               resetPasswordMutation.isLoading || 
               verifyTokenMutation.isLoading,
    error: forgotPasswordMutation.error || 
           resetPasswordMutation.error || 
           verifyTokenMutation.error,
    isSuccess: forgotPasswordMutation.isSuccess || 
               resetPasswordMutation.isSuccess || 
               verifyTokenMutation.isSuccess
  };
};